// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';

import {
  ConfigProvider, message, Layout, Menu, Carousel, Icon, Card, Pagination, Form, FormModel, Input,
  Spin, Tabs, Table, Empty, Button, Select, Modal, Breadcrumb, Radio, Row, Col, DatePicker, Cascader
} from 'ant-design-vue';
import axios from 'axios';
import Common from "@/tools/common";
import store from '@/store/store.js';
import infiniteScroll from 'vue-infinite-scroll';

Vue.component(Cascader.name, Cascader)
Vue.component(DatePicker.name, DatePicker)
Vue.component(DatePicker.RangePicker.name, DatePicker.RangePicker)
Vue.component(DatePicker.MonthPicker.name, DatePicker.MonthPicker)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.use(FormModel);
Vue.component(Radio.name, Radio)
Vue.component(Radio.Group.name, Radio.Group)
Vue.component(Breadcrumb.name, Breadcrumb)
Vue.component(Breadcrumb.Item.name, Breadcrumb.Item)
Vue.use(Modal)
Vue.prototype.$confirm = Modal.confirm;
Vue.component(Select.name, Select)
Vue.component(Select.Option.name, Select.Option)
Vue.component(Button.name, Button)
Vue.component(Empty.name, Empty)
Vue.component(Table.name, Table)
Vue.component(Tabs.name, Tabs)
Vue.component(Tabs.TabPane.name, Tabs.TabPane)
Vue.component(Spin.name, Spin)
Vue.use(infiniteScroll)
Vue.component(Input.name, Input)
Vue.component(Form.name, Form)
Vue.component(Form.Item.name, Form.Item)
Vue.component(Pagination.name, Pagination)
Vue.component(Card.name, Card)
Vue.component(Icon.name, Icon)
Vue.component(Carousel.name, Carousel)
Vue.component(ConfigProvider.name, ConfigProvider);
Vue.component(Layout.name, Layout)
Vue.component(Layout.Header.name, Layout.Header)
Vue.component(Layout.Footer.name, Layout.Footer)
Vue.component(Layout.Content.name, Layout.Content)
Vue.component(Menu.name, Menu)
Vue.component(Menu.Item.name, Menu.Item)
Vue.component(Menu.SubMenu.name, Menu.SubMenu)
Vue.component(Menu.ItemGroup.name, Menu.ItemGroup)
axios.defaults.baseURL = Common.path;
Vue.prototype.$http = axios;
Vue.config.productionTip = false
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
})

//注入全局属性$message
// import { message} from 'ant-design-vue'
Vue.prototype.$message = message;
message.config({
  duration: 1,// 持续时间
  // top:`100px`, // 到页面顶部距离
  maxCount: 2 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js